import { Button, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { BeatLoader } from 'react-spinners'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'

const AppButton = ({
	disabled,
	onClick,
	inputSx,
	title,
	variant,
	type,
	link,
	loading
}) => {
	const { theme, t } = useDefaultComponentTools()
	const defaultStyles = {
		background: theme.palette.blue,
		height: '56px',
		width: '100%', ...inputSx
	}

	return (
		<Button
			disabled={disabled}
			type={type}
			variant={variant || 'contained'}
			sx={defaultStyles}
			href={link}
			target={link ? '_blank' : null}
			onClick={onClick}>
			{loading ? <BeatLoader
				margin={3}
				speedMultiplier={1}
			/> : <Typography>{t(title)}</Typography>}
		</Button>
	)
}

AppButton.propTypes = {
	disabled: PropTypes.bool,
	inputSx: PropTypes.object,
	link: PropTypes.string,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	type: PropTypes.string,
	variant: PropTypes.string
}

export default AppButton
